import { request } from './client.js';

export type ServiceAnnouncement = import('@andresot/protocol/envelope').ServiceAnnouncementPayload;

export async function claimAnnouncements(): Promise<ServiceAnnouncement[]> {
	return (await request<{ announcements: ServiceAnnouncement[] }>('/api/announcements'))
		.announcements;
}

/** Нажатие кнопки-ссылки под рассылкой — для статистики «нажали». */
export async function recordBroadcastClick(messageId: string): Promise<void> {
	await request('/api/announcements/click', { body: { messageId } });
}
